import { ReactNode } from 'react';
import { prepareHtml } from 'core/common/utils/prepareHtml';
import { PaymentError as PaymentFormError } from 'core/flow/entities';
import { PaymentErrorLayout } from '../PaymentErrorLayout';

type PaymentErrorProps = {
  content: PaymentFormError;
  onTryAgain: () => void;
  expressButton?: ReactNode;
};

export const PaymentError = ({ content, onTryAgain, expressButton }: PaymentErrorProps) => {
  const { image, button, title, caption, solution, tip } = content;

  const descriptions = tip ? [solution, tip] : [solution];

  return (
    <PaymentErrorLayout
      image={image}
      title={title}
      descriptions={descriptions}
      caption={<span dangerouslySetInnerHTML={prepareHtml(caption)} />}
      button={button}
      expressButton={expressButton}
      onTryAgain={onTryAgain}
    />
  );
};
